import { loginApi, registerApi, authApi } from '@api/AuthApiList';
import { USER_LOGIN } from './types';

export const handleAuth = async ({ values, type }) => {
  try {
    const { data: user } =
      type === USER_LOGIN ? await loginApi(values) : await registerApi(values);

    return user;
  } catch (e) {
    if (type === USER_LOGIN) {
      throw new Error('Login fail');
    } else {
      throw new Error('Sign Up fail');
    }
  }
};

export const handleUserData = async (token) => {
  try {
    const { data: user } = await authApi(token);
    return user;
  } catch (e) {
    throw new Error('User 정보를 불러오는데 실패했습니다!');
  }
};
